<!-- <planogram-options class="px-5 py-3 bg-dark text-white shadow-lg"></planogram-options> -->
@if (layout) {
  <div class="planogram-container" cdkDropListGroup>
    <app-product-bin>
    </app-product-bin>
    <div class="layout-container">
      <app-planogram-manual-layout
        [class.visual-analysis-open]="visualAnalysisService.open$ | async"
        [class.legend-open]="legendOpen$ | async">
      </app-planogram-manual-layout>
    </div>
    <app-planogram-toolbox></app-planogram-toolbox>
  </div>
  <app-visual-analysis-overlay></app-visual-analysis-overlay>
  <app-floating-shelf></app-floating-shelf>
}

@if (showLoadingSpinner) {
  <div class="loading-overlay" @fadeInOut>
    <div class="loading-content">
      <svg class="loading-spinner" width="60" height="60" viewBox="0 0 50 50"><circle cx="25" cy="25" r="8" fill="none" stroke="#60A5FA" stroke-width="1" opacity="0"><animate attributeName="r" from="8" to="20" dur="2s" begin="0s" repeatCount="indefinite"></animate><animate attributeName="opacity" from="1" to="0" dur="2s" begin="0s" repeatCount="indefinite"></animate></circle><circle cx="25" cy="25" r="8" fill="none" stroke="#60A5FA" stroke-width="1" opacity="0"><animate attributeName="r" from="8" to="20" dur="2s" begin="0.6s" repeatCount="indefinite"></animate><animate attributeName="opacity" from="1" to="0" dur="2s" begin="0.6s" repeatCount="indefinite"></animate></circle><circle cx="25" cy="25" r="8" fill="none" stroke="#60A5FA" stroke-width="1" opacity="0"><animate attributeName="r" from="8" to="20" dur="2s" begin="1.2s" repeatCount="indefinite"></animate><animate attributeName="opacity" from="1" to="0" dur="2s" begin="1.2s" repeatCount="indefinite"></animate></circle><circle cx="25" cy="25" r="8" fill="#60A5FA"><animate attributeName="r" values="6;8;6" dur="1s" repeatCount="indefinite"></animate></circle></svg>
      <p class="lead m-0">Generating Planogram</p>
    </div>
  </div>
}